
export const CDP_PUBLIC_URL =
    window.env && window.env.PUBLIC_URL
        ? window.env.PUBLIC_URL
        : (process.env && process.env.PUBLIC_URL
            ? process.env.PUBLIC_URL
            : '/forms')

export const CORP_SITE_URL =
    window.env && window.env.PUBLIC_URL
        ? window.env.PUBLIC_URL
        : (process.env && process.env.PUBLIC_URL
            ? process.env.PUBLIC_URL
            : '/forms')

export const CDP_API_URL =
    window.env && window.env.REACT_APP_API_HOST
        ? window.env.REACT_APP_API_HOST
        : (process.env && process.env.REACT_APP_API_HOST
            ? process.env.REACT_APP_API_HOST
            : 'https://az-9892-gw.dev.metlife.co.jp/corporatesite-api/v1/applications')

export const RECAPTCHA_SECURITY_KEY = '6LemGKUnAAAAAPqLRvXKWPOtPeuhQ_rcR_53qZqB'
export const REACT_APP_SITE_KEY = (window.env && window.env.REACT_APP_SITE_KEY)
    ? window.env.REACT_APP_SITE_KEY
    : ((process.env && process.env.REACT_APP_SITE_KEY)
        ? process.env.REACT_APP_SITE_KEY
        : '')
export const RECAPTCHA_ENABLED =
    (window.env && window.env.RECAPTCHA_ENABLED)
        ? window.env.RECAPTCHA_ENABLED
        : ((process.env && process.env.RECAPTCHA_ENABLED)
            ? process.env.RECAPTCHA_ENABLED
            : false)
export const OFFICE_LIST_URL = 'http://www.metlife.co.jp/recruit/consultant/agency/'

export const METLIFE_GOVERNANCE_URL = 'https://www.metlife.co.jp/about/governance/ev-ssl/#h2Area03'
export const METLIFE_PRIVACY_POLICY_URL = 'https://www.metlife.co.jp/about/governance/privacy-policy/individual/'
export const METLIFE_TERMS_OF_USE_URL = 'https://www.metlife.co.jp/terms_of_use.html'
export const METLIFE_CONTACT_URL = 'https://www.metlife.co.jp/customer/contact/#secCall'
export const METLIFE_CONTACT_PAGE_URL = 'https://www.metlife.co.jp/contact/'
export const GOOGLE_RECAPTCHA_JS_URL = 'https://google.com/recaptcha/api.js?render='
export const JAPAN_POSTAL_BANK = 'ゆうちょ銀行'
export const JAPAN_POST_ACCOUNT_LENGTH = 8
export const JAPAN_POST_SYMBOL_LENGTH = 5
export const NAME_MAX_LENGTH = 30
export const FULL_WIDTH_TO_HALF_WIDTH_DIFFERENCE = 65248
export const REGEX_FULL_WIDTH_NUMBERS = /[\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A]/g
export const REGEX_NUMBERIC = /^[0-9０-９]+$/
export const REGEX_ALPHA_NUMBERIC = /^[0-9０-９Ａ-ＺA-Za-zａ-ｚ]+$/
export const NUMERIC_FIELDS_ARRAY = ['zip', 'age', 'phoneNumber', 'policyNumber', 'acctNum', 'branchNm']

export const IDLE_TIMEOUT =
    window.env && window.env.IDLE_TIMEOUT
        ? window.env.IDLE_TIMEOUT
        : (process.env && process.env.IDLE_TIMEOUT
            ? process.env.IDLE_TIMEOUT
            : 30)
